








import Vue from "vue";
import AdminRegisterForm from "@/components/Admin/AdminRegisterForm.vue";
import { AdminService } from "../services";
import { Role } from "../services/vo";
import { Credentials } from "vue/types/vue";
export default Vue.extend({
  name: "Register",
  components: {
    AdminRegisterForm
  },
  data() {
    return {
      refresh: 0,
      success: false,
      newUser : ""
    }
  },
  methods: {
    register: async function(
      uname: string,
      pw: string,
      role: number
    ): Promise<void> {
      this.newUser = uname;
      const cred: Credentials = {
        username: uname,
        password: pw,
        role: role
      };
      
      if(await AdminService.registerUser(cred))
      {
        this.refresh = Math.random();
        this.success = true;
      }

    }
  }
});
